import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductConfigurator"] */ "/app/src/components/pricing/ProductConfigurator.tsx");
